import { ActionEvent, Controller } from "@hotwired/stimulus"
import { create, get } from "@github/webauthn-json"

export default class extends Controller {
  static targets = [ "nickname" ]

  declare readonly nicknameTarget: HTMLInputElement
  declare readonly hasNicknameTarget: boolean

  connect() {
    if (!window.PublicKeyCredential) {
      (this.element as HTMLElement).hidden = true
    }
  }

  async register(event: ActionEvent) {
    event.preventDefault()

    const nickname = this.hasNicknameTarget ? this.nicknameTarget.value : ""

    const options = await this.fetchOptions("/passkeys/options")
    if (!options) return this.reloadPasskeys(nickname, true)

    let credential
    try {
      credential = await create({ publicKey: options })
    } catch {
      return this.reloadPasskeys(nickname, true)
    }

    const response = await fetch("/passkeys", {
      method: "POST",
      headers: this.jsonHeaders(),
      body: JSON.stringify({ credential: JSON.stringify(credential), nickname }),
    })

    if (response.ok) {
      window.location.href = "/passkeys"
    } else {
      this.reloadPasskeys(nickname, false)
    }
  }

  async login(event: ActionEvent) {
    event.preventDefault()

    const options = await this.fetchOptions("/login/passkey_options")
    if (!options) return (window.location.href = "/login?passkey_error=1")

    let credential
    try {
      credential = await get({ publicKey: options })
    } catch {
      return (window.location.href = "/login?passkey_error=1")
    }

    const response = await fetch("/login/passkey", {
      method: "POST",
      headers: this.jsonHeaders(),
      body: JSON.stringify({ credential: JSON.stringify(credential) }),
    })

    window.location.href = response.ok ? "/" : "/login"
  }

  private async fetchOptions(url: string) {
    const response = await fetch(url, { headers: { Accept: "application/json" } })
    if (!response.ok) return null

    return response.json()
  }

  private reloadPasskeys(nickname: string, clientError: boolean) {
    const params = new URLSearchParams({ nickname })
    if (clientError) params.set("passkey_error", "1")

    window.location.href = `/passkeys?${params}`
  }

  private jsonHeaders() {
    const csrfToken = document.querySelector<HTMLMetaElement>("meta[name='csrf-token']")?.content

    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    }
  }
}
